import {
  Component as ApiComponent,
  ComponentDto,
  ComponentGroup as ApiComponentGroup,
  DataType as ApiDataType,
  Variable as ApiVariable,
  VariableAttribute as ApiVariableAttribute,
  VariableDto
} from '@infuse/api/cpms/operator';
import {
  AttributeType,
  Component,
  ComponentGroup,
  CreateVariable,
  DataType,
  Mutability,
  Variable,
  VariableAttribute
} from './model';

/*
  Functions for converting from API model to Store model and back.
 */

export const apiComponentGroupToComponentGroup = (apiComponentGroup: ApiComponentGroup): ComponentGroup | undefined => {
  if (!apiComponentGroup) {
    return undefined;
  }

  return convertComponentGroup(apiComponentGroup);
};

const convertComponentGroups = (componentGroups: ApiComponentGroup[]): ComponentGroup[] => {
  if (componentGroups) {
    return componentGroups.map(convertComponentGroup);
  } else {
    return [];
  }
};

const convertComponentGroup = (apiComponentGroup: ApiComponentGroup): ComponentGroup => ({
  type: apiComponentGroup.type,
  evseId: apiComponentGroup.evseId,
  connectorId: apiComponentGroup.connectorId,

  components: convertComponents(apiComponentGroup.components),
  componentGroups: convertComponentGroups(apiComponentGroup.componentGroups)
});

const convertComponents = (components: ApiComponent[]): Component[] => {
  if (components) {
    return components.map(convertComponent);
  } else {
    return [];
  }
};

const convertComponent = (component: ApiComponent): Component => ({
  name: component.name,
  instance: component.instance,

  variables: convertVariables(component.variables)
});

const convertVariables = (variables: ApiVariable[]): Variable[] => {
  if (variables) {
    return variables.map(convertVariable);
  } else {
    return [];
  }
};

const convertVariable = (variable: ApiVariable): Variable => ({
  name: variable.name,
  instance: variable.instance,

  unit: variable.unit,
  dataType: convertToDataType(variable.dataType),
  minLimit: variable.minLimit,
  maxLimit: variable.maxLimit,
  enumValues: variable.enumValues,
  supportsMonitoring: variable.supportsMonitoring,

  attributes: convertVariableAttributes(variable.variableAttributes)
});

const convertToDataType = (type: ApiDataType): DataType => {
  switch (type) {
    case ApiDataType.BOOLEAN:
      return DataType.BOOLEAN;
    case ApiDataType.DATE_TIME:
      return DataType.DATE_TIME;
    case ApiDataType.DECIMAL:
      return DataType.DECIMAL;
    case ApiDataType.INTEGER:
      return DataType.INTEGER;
    case ApiDataType.MEMBER_LIST:
      return DataType.MEMBER_LIST;
    case ApiDataType.OPTION_LIST:
      return DataType.OPTION_LIST;
    case ApiDataType.SEQUENCE_LIST:
      return DataType.SEQUENCE_LIST;
    case ApiDataType.STRING:
    default:
      return DataType.STRING;
  }
};

const convertVariableAttributes = (variableAttributes: ApiVariableAttribute[]): VariableAttribute[] => {
  if (variableAttributes) {
    return variableAttributes.map(convertVariableAttribute);
  } else {
    return [];
  }
};

const convertVariableAttribute = (variableAttribute: ApiVariableAttribute): VariableAttribute => ({
  type: AttributeType[variableAttribute.type],
  value: variableAttribute.value,
  mutability: Mutability[variableAttribute.mutability],
  persistent: variableAttribute.persistent,
  constant: variableAttribute.constant
});

//region Domain to DTO mapping
export const mapDomainToComponentDto = (componentGroup: ComponentGroup, component: Component): ComponentDto => {
  return {
    name: component.name,
    instance: component.instance,
    evseConnector: componentGroup.evseId
      ? { evseId: componentGroup.evseId, connectorId: componentGroup.connectorId }
      : undefined
  };
};

export const mapDomainToVariableDto = (variable: Variable | CreateVariable): VariableDto => {
  return {
    name: variable.name,
    instance: variable.instance
  };
};
//endregion
